import styled, {keyframes} from "styled-components";

const VideoSlidePlayerSkeletonAnimation = keyframes`
    0% {
        background-color: #474747;
    }
    100% {
        background-color: #333333;
    }    
`;

export const VideoSlidePlayerSkeletonBox = styled.div`
    height: 33%;
    
    animation: ${VideoSlidePlayerSkeletonAnimation} 1.5s linear infinite;
`;